import React from 'react';
export interface FilterPillProps {
  /** Display label for the filter */
  label: string;
  /** Filter value identifier */
  value: string;
  /** Whether this filter is currently active */
  isActive: boolean;
  /** Callback when pill is clicked */
  onClick: (value: string) => void;
  /** Optional data-id for component identification */
  'data-id'?: string;
}
/**
 * FilterPill - Ocean Design System
 *
 * A pill-shaped filter button matching the subscription page filter chips.
 * Active: Light blue background with blue border.
 * Inactive: White background with gray border.
 */
export function FilterPill({
  label,
  value,
  isActive,
  onClick,
  'data-id': dataId
}: FilterPillProps) {
  return <button onClick={() => onClick(value)} className={`h-10 px-4 text-[14px] font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#0EA5E9]/20 ${isActive ? 'bg-[#E0F2FE] border border-[#0EA5E9] text-[#0F172A] hover:bg-[#DBEAFE]' : 'bg-white border border-[#CBD5E1] text-[#475569] hover:bg-[#F1F5F9] hover:border-[#94A3B8]'}`} aria-pressed={isActive} data-id="element-2810">
      {label}
    </button>;
}